import React, { useState } from 'react';
import { getCookie, logAction } from "./log.js";
import "../css/PopUpDownload.css";

const PopUpDownload = ({ object, onClose }) => {
    /**
     * loading : état local pour gérer l'affichage du bouton pendant
     * le téléchargement asynchrone.
     */
    const [loading, setLoading] = useState(false);

    /**
     * API_URL : URL de base de l'API, tirée des variables d'environnement,
     * utilisée pour envoyer la requête de téléchargement.
     */
    const API_URL = process.env.REACT_APP_API_URL;

    /**
     * handleDownload : fonction déclenchée au clic sur "Télécharger",
     * elle :
     * - Envoie une requête POST avec les infos du fichier à télécharger.
     * - Gère la réponse et crée un lien de téléchargement dynamique.
     * - Log l'action de téléchargement si succès.
     * - Affiche une alerte en cas d'erreur.
     */
    const handleDownload = async () => {
        setLoading(true);
        try {
            const fileWithPath = {
                ...object,
                path: object.path,
            };

            const response = await fetch(`${API_URL}/api/downloadFile.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                    file: fileWithPath,
                }),
            });

            if (response.ok) {
                logAction({
                    action: "downloadFile",
                    dossierId: object.id,
                    utilisateurId: getCookie("userId"),
                    fichier: object.name,
                    path: object.path,
                });

                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", object.name);
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                const err = await response.json();
                alert(err.error || "Erreur lors du téléchargement.");
            }
        } catch (error) {
            console.error("Erreur lors du téléchargement :", error);
            alert("Erreur lors du téléchargement.");
        } finally {
            setLoading(false);
            onClose();
        }
    };

    return (
        <div className="popupDownload-overlay">
            <div className="popupDownload-content">
                Télécharger le fichier : <h3>{object.name}</h3>
                <div className="flex justify-end -popupDownload-actions">
                    <button className='btn btn-accent mr-2' onClick={handleDownload} disabled={loading}>
                        {loading ? "Chargement..." : "Télécharger"}
                    </button>
                    <button className='btn' onClick={onClose}>Fermer</button>
                </div>
            </div>
        </div>
    );
};

export default PopUpDownload;
